<template>
    <section class="free-measurement-location">
        <div class="container">
            <div
                class="free-measurement-location__search-title free-measurement-location__search-title_mobile"
            >
                Проверьте свой адрес
                <img
                    src="./../../assets/img/free-measurement/adress-vector_mobile.svg"
                    alt="adress-vector_mobile"
                    class="free-measurement-location__search-svg free-measurement-location__search-svg_mobile"
                />
            </div>
            <div class="free-measurement-location__search">
                <div
                    class="free-measurement-location__search-title free-measurement-location__search-title_desktop"
                >
                    Проверьте свой адрес
                    <img
                        src="./../../assets/img/free-measurement/adress-vector_desktop.svg"
                        alt="adress-vector_desktop"
                        class="free-measurement-location__search-svg free-measurement-location__search-svg_desktop"
                    />
                </div>
                <input
                    type="text"
                    class="free-measurement-location__search-input"
                    placeholder="Введите свой адрес"
                />
            </div>
            <div class="free-measurement-location__availability">
                <div
                    class="free-measurement-location__availability-condition"
                ></div>
                <div class="free-measurement-location__availability-title">
                    Доступно для бесплатной доставки
                </div>
            </div>
            <iframe
                class="free-measurement-location__map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3568.9194992050134!2d-80.1010387!3d26.5548539!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d8df208877e343%3A0xeeeca5b1b3279236!2z0JHQvtC50L3RgtC-0L0g0JHQuNGHLCDQpNC70L7RgNC40LTQsCwg0KHQqNCQ!5e0!3m2!1sru!2sru!4v1649942554101!5m2!1sru!2sru"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe>
        </div>
    </section>
</template>

<script>
export default {
    name: 'check-address',
};
</script>
